const ACTION_COLOR_LIVESITE = "var(--ricos-native-text-color,  var(--ricos-action-color, #116dff))";
const BG_COLOR_LIVESITE = "var(--ricos-native-secondary-bg-color-background-color, rgba(var(--ricos-text-color-low-tuple, 150, 150, 150),.2) )";
const SLIDER_THUMB_VISIBILITY = { hover: "hover", fixed: "fixed" };
const SLIDER_TRACK_SIZE = { small: "small_track", medium: "medium_track" };
const PANEL_HEADER_ID = "panel-header";
export {
  ACTION_COLOR_LIVESITE,
  BG_COLOR_LIVESITE,
  PANEL_HEADER_ID,
  SLIDER_THUMB_VISIBILITY,
  SLIDER_TRACK_SIZE
};
//# sourceMappingURL=consts.js.map
